import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from '../components/UI';

function DashboardMock() {
  const bars = [40, 65, 50, 80, 70, 90, 75, 95, 85, 100, 88, 92];
  return (
    <div className="dashboard-mock">
      <div className="mock-header">
        <div className="mock-dots">
          <span /><span /><span />
        </div>
        <div className="mock-title">CevFİN Ekosistemi · Canlı Görünüm</div>
        <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--emerald-500)', boxShadow: '0 0 6px var(--emerald-500)' }} />
      </div>
      <div className="mock-metrics">
        <div className="mock-metric">
          <div className="mock-metric-label">Analiz Edilen E-Defter</div>
          <div className="mock-metric-val">19.000+ Defter</div>
          <div className="mock-metric-sub">▲ +12.4% bu ay</div>
        </div>
        <div className="mock-metric">
          <div className="mock-metric-label">Analiz Edilen E-Faturalar</div>
          <div className="mock-metric-val">1.500.000+</div>
          <div className="mock-metric-sub">↳ %100 online hata tespiti</div>
        </div>
         <div className="mock-metric">
          <div className="mock-metric-label">GİB Sorgulamaları</div>
          <div className="mock-metric-val">100.000+ Adet</div>
          <div className="mock-metric-sub">Başarıyla İşlendi</div>
        </div>
         <div className="mock-metric">
          <div className="mock-metric-label">SGK Sorgulamaları</div>
          <div className="mock-metric-val">100.000 Bildirge</div>
          <div className="mock-metric-sub">✓ Uyumlu</div>
        </div>
      </div>
      {/* <div className="mock-chart-area">
        <div className="chart-bars">
          {bars.map((h, i) => (
            <div
              key={i}
              className="chart-bar"
              style={{ height: `${h}%`, animationDelay: `${i * 0.05}s` }}
            />
          ))}
        </div>
      </div> */}
      <div className="mock-list">
        {[
          { label: 'E-Defter Yükleme - GİB Analizi', val: '', badge: 'badge-green', badgeText: 'Program bağımsız' },
          { label: 'TCMB Kurları', val: '', badge: 'badge-green', badgeText: 'Gün-Ay-Çeyrek-Yıl' },
          { label: 'E-Beyanname Analizi', val: '', badge: 'badge-green', badgeText: '100.000+' },
          { label: 'Mevzuat Takibi', val: '', badge: 'badge-green', badgeText: '18.000 Özelge+' },
        ].map((item, i) => (
          <div key={i} className="mock-list-item">
            <span className="mock-list-label">{item.label}</span>
            <span className="mock-list-val">{item.val}</span>
            <span className={`mock-list-badge ${item.badge}`}>{item.badgeText}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function CounterNumber({ target, suffix = '' }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let current = 0;
    const step = target / (1800 / 16);
    const update = () => {
      current = Math.min(current + step, target);
      el.textContent = Math.floor(current);
      if (current < target) requestAnimationFrame(update);
    };
    requestAnimationFrame(update);
  }, [target]);
  return <span ref={ref}>0</span>;
}

const features = [
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    ),
    title: 'E-DEFTER',
    desc: 'Program Bağımsız. Tüm programlardan gelen E-Defterler tek altyapıda analiz ve raporlama',
  },
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
      </svg>
    ),
    title: 'E-FATURA',
    desc: 'Kullandığınız Entegratör değişmeden eş zamanlı analiz ve raporlama elinizin altında',
  },
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    title: 'E-Beyanname',
    desc: 'Birden fazla meslek mensubu tek ekrandan Beyanname Yönetim, Analiz ve Raporlaması',
  },
  {
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
      </svg>
    ),
    title: 'Dijital GİB',
    desc: 'Tüm Müşteriler ve meslek mensupları için şifresiz Dijital GİB Giriş, Sorgulama ve Raporlama',
  },
];

export default function HomePage() {
  return (
    <div className="page-enter">
      {/* ===== HERO ===== */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-grid" />
          <div className="hero-glow-1" />
          <div className="hero-glow-2" />
        </div>
        <div className="container hero-content">
          <div className="hero-inner">
            <div className="hero-text">
              <div className="hero-badge">
                <FadeIn>
                  <span className="badge">
                    <span className="badge-dot" />
                    Holistik Yaklaşımla Muhasebe Teknolojileri Ağı
                  </span>
                </FadeIn>
              </div>
              <FadeIn delay={0.1}>
                <h1 className="hero-title">
                  Program Değiştirmeden<br />
                  <span className="gradient">Geleceği Yaşayın</span>
                </h1>
              </FadeIn>
              <FadeIn delay={1.0}>
                <p className="hero-desc">
                  Sıradan bir yazılım değil; E-Belge, E-Defter, Beyanname, SGK, Dijital Vergi Dairesi
                  tek çatı altında ve her modülün birbiriyle entegre çalıştığı holistik (bütünsel) bir muhasebe dünyasındasınız.
                </p>
                <p className="badge badge-green" style={{ display: 'inline-block', marginTop: 16,marginBottom: 16 }}>On-Premise ve Cloud Altyapı Desteği</p>
              </FadeIn>
              <FadeIn delay={0.3}>
                <div className="hero-actions">
                  <Link to="/iletisim" className="btn btn-primary btn-lg">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                    </svg>
                    Ekosisteme Katıl
                  </Link>
                  <button className="btn btn-outline btn-lg" onClick={() => alert('Demo videosu yakında yayında olacak!\nBu arada Demo Talep Edin, uzmanlarımız sizi arasın.')}>
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
                    </svg>
                    Demo İzle
                  </button>
                </div>
              </FadeIn>
              <FadeIn delay={0.4}>
                <div className="hero-stats">
                  <div className="hero-stat-item">
                    <div className="hero-stat-num"><CounterNumber target={100} />+</div>
                    <div className="hero-stat-label">Aktif Müşteri</div>
                  </div>
                  <div className="stat-divider" />
                  <div className="hero-stat-item">
                    <div className="hero-stat-num"><CounterNumber target={99} />.9%</div>
                    <div className="hero-stat-label">Güncelleme Garantisi</div>
                  </div>
                  <div className="stat-divider" />
                  <div className="hero-stat-item">
                    <div className="hero-stat-num" style={{ color: 'var(--blue-500)' }}>7/24</div>
                    <div className="hero-stat-label">Teknik Destek</div>
                  </div>
                </div>
              </FadeIn>
            </div>

            <FadeIn delay={0.2} style={{ position: 'relative' }}>
              <DashboardMock />
            </FadeIn>
          </div>
        </div>
      </section>

      {/* ===== FEATURES ===== */}
      <section className="section" style={{ background: 'var(--white)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 64 }}>
            <FadeIn>
              <div className="section-label">Neden CevFİN?</div>
              <h2 className="section-title">Sıradan Bir Yazılım Değil <span>Holistik Platform</span></h2>
               <div className="section-label">Ekosistem</div>
               <h2 className="section-title">Tek Platformda <span>Tüm Çözümler</span></h2>
              <p className="section-desc" style={{ margin: '0 auto' }}>
                E-dönüşüm süreçlerinin tamamını entegre yönetin
              </p>
            </FadeIn>
          </div>
          <div className="features-grid">
            {features.map((f, i) => (
              <FadeIn key={i} delay={i * 0.1}>
                <div className="card feature-card">
                  <div className="icon-box" style={{ marginBottom: 20 }}>{f.icon}</div>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ===== SECURITY ===== */}
      <section className="section-sm">
        <div className="container">
          <FadeIn>
            <div className="security-section">
              <div style={{ textAlign: 'center', marginBottom: 32 }}>
                <div className="section-label">Güvenlik</div>
                <h2 className="section-title">Banka Seviyesi <span>Güvenlik Altyapısı</span></h2>
                <p style={{ color: 'var(--slate-600)', maxWidth: 520, margin: '0 auto' }}>
                  Verileriniz en üst düzey güvenlik protokolleri ile Türkiye Cumhuriyeti içinde
                  yer alan sunucularımız aracılığı ile korunmaktadır.
                </p>
              </div>
              <div className="security-grid">
                {[
                  { icon: '🔒', title: 'SSL/TLS Şifreleme', desc: '256-bit AES şifreleme' },
                  { icon: '🇹🇷', title: 'Yerli Sunucu', desc: 'TC sınırları içinde veri' },
                  { icon: '🛡️', title: 'ISO 27001', desc: 'Bilgi güvenliği standardı' },
                  { icon: '📋', title: 'KVKK Uyumlu', desc: 'Tam mevzuat uyumu' },
                ].map((item, i) => (
                  <div key={i} className="security-item">
                    <div style={{ fontSize: '2rem', marginBottom: 12 }}>{item.icon}</div>
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="section" style={{ background: 'var(--white)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <FadeIn>
            <div className="section-label">Başlayın</div>
            <h2 className="section-title" style={{ marginBottom: 24 }}>
              Ekosisteme <span>Katılmaya Hazır mısınız?</span>
            </h2>
            <p className="section-desc" style={{ margin: '0 auto 40px' }}>
              Ücretsiz demo talebi oluşturun, uzmanlarımız sizinle iletişime geçsin.
            </p>
            <Link to="/iletisim" className="btn btn-primary btn-lg">
              <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
              Ücretsiz Demo Talep Et
            </Link>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
